import _ from 'lodash';
// import objectAssign from 'object-assign';
import * as types from '../constants/actionTypes';
import 'whatwg-fetch';
import * as utils from './actionUtils';
import moment from 'moment-timezone';
import 'moment/locale/nb';
// import toastr from 'toastr';
// import { push } from 'react-router-redux';

let defaultDelay = 0;
if (process.env.NODE_ENV === 'development') {
  defaultDelay = 200;
}


export function loadReportDetails(url, reducer, date) {
  return function (dispatch) {
    utils.streamData('reports/' + url,
      (result) => {dispatch(loadReportDetailsSuccess(result, reducer, date));},
      (error) => {dispatch(loadReportDetailsFail(error));},
      defaultDelay);
    dispatch({
      type: types.LOAD_REPORT_DETAILS,
    });
  };
}

export function loadReportDetailsSuccess(details, date, dataType) {
  return function (dispatch, getState) {
    let currentReportData = _.cloneDeep(getState().reports.reportData);
    if (!currentReportData[moment(date).format('YYYYMMDD')]) {
      currentReportData[moment(date).format('YYYYMMDD')] = {};
    }
    currentReportData[moment(date).format('YYYYMMDD')][dataType] = JSON.parse(details);
    dispatch({
      type: types.LOAD_REPORT_DATA_SUCCESS,
      details: currentReportData,
      detailsUpdated: Date.now(),
    });
  };
}


export function loadReportDetailsFail(errors) {
  return function(dispatch) {
    dispatch({
      type: types.LOAD_REPORT_DETAILS_FAILURE,
      errors: errors,
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/reportActions.js
 **/